

import { TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { LayoutTabla } from "../../layout";
import { separadorMillares } from "../../../helpers";




export const DetalleDeFactura = ({ data }) => {



    return (

        <LayoutTabla>
            <TableHead>
                <TableRow>
                    <TableCell><strong>Producto</strong></TableCell>
                    <TableCell><strong>Cantidad</strong></TableCell>
                    <TableCell><strong>Precio Uni.</strong></TableCell>
                    <TableCell><strong>Total</strong></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {data?.productos?.map((item) => (
                <TableRow hover key={item._id}>
                    <TableCell>{item?.producto?.nombre}</TableCell>
                    <TableCell>{item?.cantidad}</TableCell>
                    <TableCell>{`$${separadorMillares(item?.precioUnitario)}`}</TableCell>
                    <TableCell>{`$${separadorMillares(item?.total)}`}</TableCell>
                </TableRow>
                ))}

                <TableRow>
                    <TableCell colSpan={3} align="right">
                        <Typography variant="h2">Total</Typography>
                    </TableCell>
                    <TableCell>
                        <Typography variant="h2">{`$${separadorMillares(data?.total)}`}</Typography>
                    </TableCell>
                </TableRow>
            </TableBody>
        </LayoutTabla>
    )
}
